import styled from 'styled-components';

import {getAlphaColor} from '../../../../styles';
import {View} from '../../../../uikit/View';

export const Container = styled(View)`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${getAlphaColor('background.white', 0.8)};
  z-index: 3;
`;
